export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $('.animated-digit').each(function () {
      $(this).prop('Counter',0).animate({
        Counter: $(this).text(),
      }, {
        duration: 1500,
        easing: 'swing',
        step: function (now) {
          $(this).text(Math.ceil(now));
        },
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive.js